import React from 'react';
import styled from '@emotion/styled';
import type { WCmsHomepageSectionView } from '@zola/svc-web-api-ts-client';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import Story from './Story';

const StorySection = ({
  homepageSections,
  className,
}: {
  homepageSections?: WCmsHomepageSectionView[];
  className?: string;
}): JSX.Element | null => {
  const Container = styled.div`
    margin-top: 80px;
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
    padding-bottom: 100px;
    ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
      padding-bottom: 40px;
    }
    > div:not(:first-child) {
      margin-top: 100px;
    }
  `;

  if (homepageSections && homepageSections.length > 0) {
    return (
      <Container className={className}>
        {homepageSections.map((s, i) => (
          <Story {...s} key={i} />
        ))}
      </Container>
    );
  }

  return null;
};

export default StorySection;
